export default __webpack_public_path__ + "static/help_06_03-5-b24ab256e38c6cc0dd532d680444c0eb.png";